import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
const AdminRoute = ({ path, component, exact }) => {

    
  const { myInfo } = useSelector((state) => state.Auth);

  if (!myInfo) {
    return <Redirect to="/register" />;
  } else {
    if (myInfo.email === "iasraful107@gmail.com") {
      return <Route path={path} component={component} exact={exact} />;
    }else {
        return <Redirect to='/' />
    }
  }
};

export default AdminRoute;
